import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import ProductCategoriesList from '@shared/product_categories/ProductCategoriesList'
import ListPageHeader from '@shared/ListPageHeader'

import { productCategoryService } from '@services/operator/productCategoryService'

export default function OperatorProductCategoriesList() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.product_categories']}
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/product_categories/new')}>
            {t('common.button.new')}
          </Button>
        }
      />
      <ProductCategoriesList
        role="operator"
        service={productCategoryService}
      />
    </div>
  )
}
